/* mo-tier.js: tier article frame and step-up drawing runtime (sections/mo-tier.liquid), Mattress Overstock, 2026-10-15.
   Feel and build (radio groups, arrows/Home/End): each tier column shows its bed for that feel and build, and the
   drawing redraws (assets/mo-tier-draw.js): layers that both drawings share glide to their new depth, new layers slide
   in from the side of the tier below. Size: reprice every card from its own variants (cents, rendered by Liquid into
   data-prices) and say so in a polite live region. An optional tier (Series Two) can be added to both.
   First view of the drawing: what each upper tier adds slides out and back in, once; then it waits. Reduced motion:
   no movement. Contents rail: ids on the body's H2s in order, current section marked while reading.
   No DOM writes inside a repaint; every write is guarded so the theme's body MutationObserver cannot loop. */
(function () {
  'use strict';

  function money(cents) {
    var d = cents / 100, whole = Math.round(d) === d;
    return '$' + d.toLocaleString('en-US', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
  }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function setHidden(el, h) { if (el && el.hidden !== h) el.hidden = h; }
  function setAttr(el, k, v) { if (el && el.getAttribute(k) !== v) el.setAttribute(k, v); }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // a damped spring from 0 to 1 (slight overshoot), t in seconds
  function spring(t) {
    var w = 15, z = 0.64, wd = w * Math.sqrt(1 - z * z);
    return 1 - Math.exp(-z * w * t) * (Math.cos(wd * t) + (z * w / wd) * Math.sin(wd * t));
  }

  function boot(root) {
    var D = window.MOTierDraw;
    var dataEl = root.querySelector('[data-tl-data]'), data = null;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { data = null; }
    var state = { feel: root.getAttribute('data-feel'), build: root.getAttribute('data-build'), size: root.getAttribute('data-size') || 'Queen', extra: false };
    var cards = [].slice.call(root.querySelectorAll('[data-tier-bed]'));
    var cols = [].slice.call(root.querySelectorAll('[data-tier-col]'));
    var sizeSel = root.querySelector('[data-tier-size]');
    var live = root.querySelector('[data-tier-live]');
    var panel = root.querySelector('[data-tl-panel]');
    var draw = root.querySelector('[data-tl-draw]');
    var readout = root.querySelector('[data-tl-readout]');
    var labels = {};
    if (data) {
      data.feels.forEach(function (f) { labels['f:' + f.key] = f.label; });
      data.builds.forEach(function (b) { labels['b:' + b.key] = b.label; });
    }

    /* ------------------------------------------------------------ cards and prices */
    function priceCard(card, size) {
      var map; try { map = JSON.parse(card.getAttribute('data-prices')); } catch (e) { return; }
      var row = map[size], amt = card.querySelector('[data-tier-price]'), was = card.querySelector('[data-tier-was]'), lab = card.querySelector('[data-tier-sizelabel]');
      if (!row) { setText(amt, 'Not carried in ' + size); setHidden(was, true); setHidden(lab, true); card.classList.add('is-nosize'); return; }
      card.classList.remove('is-nosize');
      setText(amt, money(row[0]));
      if (row[1] > row[0]) { setText(was, money(row[1])); setHidden(was, false); } else setHidden(was, true);
      setText(lab, size); setHidden(lab, false);
    }
    function setSize(size, say) {
      state.size = size;
      setAttr(root, 'data-size', size);
      cards.forEach(function (c) { priceCard(c, size); });
      if (say && live) setText(live, 'Prices shown for ' + size + '.');
    }

    function showCards() {
      var fl = labels['f:' + state.feel] || state.feel, bl = (labels['b:' + state.build] || state.build).toLowerCase();
      cols.forEach(function (col) {
        var key = col.getAttribute('data-tier-col'), tier = data ? data.tiers.filter(function (t) { return t.key === key; })[0] : null;
        setHidden(col, !!(tier && tier.optional && !state.extra));
        var mine = cards.filter(function (c) { return c.getAttribute('data-tier') === key; });
        var inFeel = mine.filter(function (c) { return c.getAttribute('data-feel') === state.feel; });
        var hit = inFeel.filter(function (c) { var b = c.getAttribute('data-build'); return b === state.build || b === 'any'; });
        hit.sort(function (a, b) { return (b.getAttribute('data-h') ? 1 : 0) - (a.getAttribute('data-h') ? 1 : 0); });
        var pick = hit[0] || null;
        mine.forEach(function (c) { setHidden(c, c !== pick); });
        var empty = col.querySelector('[data-tier-empty]');
        setText(empty, pick ? '' : (inFeel.length ? 'No ' + fl + ' ' + bl + ' in ' + (tier ? tier.name : key) + '.' : 'No ' + fl + ' in ' + (tier ? tier.name : key) + '.'));
        setHidden(empty, !!pick);
        // the same feel in other builds of this tier: one tap switches the build
        var also = col.querySelector('[data-tier-also]'), others = inFeel.filter(function (c) { return c !== pick && c.getAttribute('data-build') !== 'any'; });
        var seen = {}, btns = [];
        others.forEach(function (c) {
          var b = c.getAttribute('data-build');
          if (seen[b] || b === state.build) return;
          seen[b] = 1;
          btns.push('<button type="button" class="tier-chip tier-chip--also" data-tier-go="' + b + '">' + (labels['b:' + b] || b) + '</button>');
        });
        var html = btns.length ? '<span class="tier-col__also-l">' + (pick ? 'Also in ' + fl + ':' : 'In ' + fl + ':') + '</span> ' + btns.join(' ') : '';
        if (also.innerHTML !== html) also.innerHTML = html;
        setHidden(also, !btns.length);
      });
    }

    /* ------------------------------------------------------------ the drawing */
    var maxH = data ? D.maxH(data) : 0;
    function adds() { var m = {}; (data.tiers || []).forEach(function (t) { if (t.adds && t.adds.length) m[t.key] = t.adds; }); return m; }
    function stateNow() { return { look: data.look, maxH: maxH, slots: D.slots(data, state.feel, state.build, state.extra), adds: adds() }; }
    function boxes() {
      var m = {};
      draw.querySelectorAll('svg').forEach(function (svg) {
        var v = svg.getAttribute('data-narrow');
        svg.querySelectorAll('.tl-l').forEach(function (g) {
          m[v + '|' + g.getAttribute('data-k')] = [+g.getAttribute('data-x'), +g.getAttribute('data-y'), +g.getAttribute('data-w'), +g.getAttribute('data-h')];
        });
      });
      return m;
    }
    var anims = [], raf = 0;
    function tick(now) {
      raf = 0;
      var still = false;
      anims.forEach(function (a) {
        var t = (now - a.t0) / 1000 - a.delay;
        if (t < 0) { still = true; return; }
        var p = a.kind === 'out' ? Math.min(1, t / 0.34) : spring(t);
        var done = a.kind === 'out' ? p >= 1 : t > 1.1;
        var q = a.kind === 'out' ? p * p : p;
        var sx = a.sx + (1 - a.sx) * q, sy = a.sy + (1 - a.sy) * q, tx = a.tx * (1 - q), ty = a.ty * (1 - q);
        if (a.kind === 'out') { sx = 1; sy = 1; tx = a.tx * q; ty = 0; }
        if (done) { a.g.removeAttribute('transform'); a.g.style.opacity = a.kind === 'out' ? '0' : ''; a.done = true; if (a.then) { a.then(); still = true; } return; }
        a.g.setAttribute('transform', 'matrix(' + sx.toFixed(4) + ' 0 0 ' + sy.toFixed(4) + ' ' + tx.toFixed(2) + ' ' + ty.toFixed(2) + ')');
        if (a.fade) a.g.style.opacity = String(a.kind === 'out' ? 1 - q : Math.min(1, t / 0.18));
        still = true;
      });
      anims = anims.filter(function (a) { return !a.done; });
      if (still) raf = requestAnimationFrame(tick);
    }
    function play() { if (!raf && anims.length) raf = requestAnimationFrame(tick); }
    function slideIn(g, delay, dist) {
      var w = +g.getAttribute('data-w');
      g.style.opacity = '0';
      anims.push({ g: g, kind: 'in', t0: performance.now(), delay: delay, sx: 1, sy: 1, tx: -Math.max(dist, w * 0.35), ty: 0, fade: true });
    }

    function render(animate) {
      if (!data || !D) return;
      var st = stateNow(), old = animate ? boxes() : null;
      var w = D.svg(Object.assign({}, st, { narrow: false })), n = D.svg(Object.assign({}, st, { narrow: true }));
      anims = [];
      draw.innerHTML = '<div class="tl-live" data-tl-v="w">' + w + '</div><div class="tl-live" data-tl-v="n">' + n + '</div>';
      var sum = root.querySelector('[data-tl-sum]'), list = root.querySelector('[data-tl-list]');
      if (sum) sum.innerHTML = D.summary(st);
      if (list) list.innerHTML = D.list(st);
      root.querySelectorAll('[data-tl-step]').forEach(function (box) {
        var key = box.getAttribute('data-tl-step'), html = '';
        for (var si = 1; si < st.slots.length; si++) if (st.slots[si].tier.key === key) html = D.stepChips(st, si);
        if (box.innerHTML !== html) box.innerHTML = html;
      });
      if (!animate || reduce) return;
      var t0 = performance.now();
      draw.querySelectorAll('svg').forEach(function (svg) {
        var v = svg.getAttribute('data-narrow');
        svg.querySelectorAll('.tl-l').forEach(function (g) {
          var k = g.getAttribute('data-k'), ob = old[v + '|' + k];
          var nx = +g.getAttribute('data-x'), ny = +g.getAttribute('data-y'), nw = +g.getAttribute('data-w'), nh = +g.getAttribute('data-h');
          if (ob && nw > 0 && nh > 0) {
            var sx = ob[2] / nw, sy = ob[3] / nh;
            if (Math.abs(sx - 1) < 0.001 && Math.abs(sy - 1) < 0.001 && Math.abs(ob[0] - nx) < 0.1 && Math.abs(ob[1] - ny) < 0.1) return;
            anims.push({ g: g, kind: 'in', t0: t0, delay: 0, sx: sx, sy: sy, tx: ob[0] - nx * sx, ty: ob[1] - ny * sy, fade: false });
          } else {
            slideIn(g, 0.08 + (+k.split('|')[0]) * 0.07, 26);
          }
        });
      });
      panel.classList.add('is-moving');
      play();
      setTimeout(function () { panel.classList.remove('is-moving'); }, 650);
    }

    // first view: what each upper tier adds slides out toward the tier below and back in, tier by tier
    function moment(asked) {
      if (!draw || (reduce && !asked)) return;
      if (reduce) { panel.classList.add('is-flash'); setTimeout(function () { panel.classList.remove('is-flash'); }, 1200); return; }
      var t0 = performance.now(), any = false;
      draw.querySelectorAll('svg').forEach(function (svg) {
        var news = [].slice.call(svg.querySelectorAll('.tl-l.is-new'));
        news.forEach(function (g) {
          var slot = +g.getAttribute('data-k').split('|')[0], d = 0.15 + (slot - 1) * 0.9;
          var w = +g.getAttribute('data-w');
          var dx = -Math.max(30, w * 0.45);
          var out = { g: g, kind: 'out', t0: t0, delay: d, tx: dx, fade: true };
          out.then = function () { anims.push({ g: g, kind: 'in', t0: performance.now(), delay: 0.18, sx: 1, sy: 1, tx: dx, ty: 0, fade: true }); };
          anims.push(out);
          any = true;
        });
      });
      if (any) play();
    }

    /* ------------------------------------------------------------ controls */
    function group(attr, key) {
      var chips = [].slice.call(root.querySelectorAll('[' + attr + ']'));
      function set(v, emit) {
        chips.forEach(function (c) {
          var on = c.getAttribute(attr) === v;
          setAttr(c, 'aria-checked', String(on));
          c.tabIndex = on ? 0 : -1;
        });
        if (emit) emit(v);
      }
      chips.forEach(function (c, i) {
        c.addEventListener('click', function () { if (c.getAttribute('aria-checked') !== 'true') choose(key, c.getAttribute(attr)); });
        c.addEventListener('keydown', function (e) {
          var k = e.key, j = -1;
          if (k === 'ArrowRight' || k === 'ArrowDown') j = (i + 1) % chips.length;
          else if (k === 'ArrowLeft' || k === 'ArrowUp') j = (i - 1 + chips.length) % chips.length;
          else if (k === 'Home') j = 0;
          else if (k === 'End') j = chips.length - 1;
          if (j < 0) return;
          e.preventDefault();
          chips[j].focus();
          choose(key, chips[j].getAttribute(attr));
        });
      });
      return set;
    }
    var setFeel = group('data-tier-feel', 'feel'), setBuild = group('data-tier-build', 'build');

    // a build with no bed in any tier for this feel is marked, and a feel that leaves the build empty moves the build
    function marks() {
      root.querySelectorAll('[data-tier-build]').forEach(function (c) {
        var b = c.getAttribute('data-tier-build');
        var has = data.beds.some(function (x) { return x.feel === state.feel && (x.build === b || x.build === 'any') && data.tiers.some(function (t) { return t.key === x.tier && t.status !== 'gone' && (!t.optional || state.extra); }); });
        c.classList.toggle('is-none', !has);
      });
    }
    function choose(key, v) {
      state[key] = v;
      if (key === 'feel') {
        // keep the build if any tier makes this feel in it; else move to the first build that has a drawn bed, then any bed
        var has = function (bu, drawn) { return data.beds.some(function (x) { return x.feel === v && x.build === bu && (!drawn || x.height); }); };
        if (!has(state.build, true)) {
          var pick = null, i;
          for (i = 0; i < data.builds.length && !pick; i++) if (has(data.builds[i].key, true)) pick = data.builds[i].key;
          if (!pick && !has(state.build, false)) for (i = 0; i < data.builds.length && !pick; i++) if (has(data.builds[i].key, false)) pick = data.builds[i].key;
          if (pick) state.build = pick;
        }
      }
      setFeel(state.feel); setBuild(state.build);
      setAttr(root, 'data-feel', state.feel); setAttr(root, 'data-build', state.build);
      marks();
      showCards();
      render(true);
      if (live) setText(live, (labels['f:' + state.feel] || state.feel) + ', ' + (labels['b:' + state.build] || state.build).toLowerCase() + '.');
    }
    root.addEventListener('click', function (e) {
      var go = e.target.closest && e.target.closest('[data-tier-go]');
      if (go) choose('build', go.getAttribute('data-tier-go'));
    });
    var extraBtn = root.querySelector('[data-tier-extra]');
    if (extraBtn) extraBtn.addEventListener('click', function () {
      state.extra = !state.extra;
      setAttr(extraBtn, 'aria-pressed', String(state.extra));
      root.classList.toggle('has-extra', state.extra);
      marks(); showCards(); render(true);
    });
    if (sizeSel) sizeSel.addEventListener('change', function () { setSize(sizeSel.value, true); });

    /* ------------------------------------------------------------ naming a layer */
    function names(key) {
      var out = [];
      D.slots(data, state.feel, state.build, state.extra).forEach(function (sl) {
        if (!sl.bed || !sl.bed.height) return;
        (sl.bed.layers || []).forEach(function (l) { if (D.canon(l[0], l[2]) === key && out.indexOf(sl.tier.name) < 0) out.push(sl.tier.name); });
      });
      return out;
    }
    function hot(key, label) {
      var on = !!key;
      panel.classList.toggle('is-hot', on);
      panel.querySelectorAll('.tl-l, .tl-rib').forEach(function (g) { g.classList.toggle('is-hot', on && g.getAttribute('data-key') === key); });
      root.querySelectorAll('.tl-chip[data-key]').forEach(function (c) { c.classList.toggle('is-hot', on && c.getAttribute('data-key') === key); });
      if (!readout) return;
      if (!on) { setText(readout, 'Tap or point at a layer to name it.'); return; }
      var where = names(key);
      readout.innerHTML = '<b></b> <span></span>';
      readout.firstChild.textContent = label;
      readout.lastChild.textContent = where.length ? 'In ' + where.join(', ').replace(/, ([^,]*)$/, ' and $1') + '.' : '';
    }
    function layerLabel(g) {
      var k = g.getAttribute('data-k').split('|'), slot = +k[0];
      var sl = D.slots(data, state.feel, state.build, state.extra)[slot];
      if (!sl || !sl.bed) return '';
      var stx = D.stack(sl.bed), hit = null;
      if (!stx.depths) return sl.tier.name + ': layer depths not published';
      stx.list.forEach(function (x) { if (x.key === k[1] && String(x.occ) === k[2]) hit = x; });
      return hit ? hit.name + ', ' + hit.d + ' in.' : '';
    }
    if (panel && data) {
      var name = function (e) {
        var g = e.target.closest && e.target.closest('.tl-l');
        if (g) hot(g.getAttribute('data-key'), layerLabel(g));
      };
      panel.addEventListener('pointerover', name);
      panel.addEventListener('pointerdown', name);
      // a finger keeps the last layer it named; a mouse clears it on the way out
      panel.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hot(null); });
      panel.addEventListener('focusin', function (e) {
        var li = e.target.closest && e.target.closest('[data-key]');
        if (li && li.classList.contains('tl-list__li')) hot(li.getAttribute('data-key'), li.firstChild.textContent.replace(/^Added /, '') + ', ' + li.lastChild.textContent);
      });
      panel.addEventListener('focusout', function () { hot(null); });
    }

    var play2 = root.querySelector('[data-tl-play]');
    if (play2) play2.addEventListener('click', function () { anims = []; moment(true); });

    /* ------------------------------------------------------------ first state */
    if (data) {
      marks();
      // the server still is the first frame and already the live markup; it is redrawn only when the shopper changes something
      if ('IntersectionObserver' in window && !reduce) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio >= 0.5) { io.disconnect(); setTimeout(moment, 250); } });
        }, { threshold: [0.5] });
        io.observe(draw);
      }
    }
    setSize(sizeSel ? sizeSel.value : 'Queen', false);
    rail(root);
    steps(root);
    var cm = root.querySelector('#comments');
    if (cm && (location.hash === '#comments' || cm.querySelector('.tier-comments__msg'))) cm.open = true;
    root.classList.add('is-ready');
  }

  function rail(root) {
    var prose = root.querySelector('[data-tier-prose]'), nav = root.querySelector('[data-tier-rail]');
    if (!prose || !nav) return;
    var hs = [].slice.call(prose.querySelectorAll('h2'));
    hs.forEach(function (h, i) { if (!h.id) h.id = 'tier-s' + (i + 1); });
    var links = [].slice.call(nav.querySelectorAll('[data-tier-rail-a]'));
    if (!('IntersectionObserver' in window) || !links.length) return;
    var cur = null;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) cur = e.target; });
      if (!cur) return;
      var id = cur.id;
      links.forEach(function (a) {
        var on = a.getAttribute('href') === '#' + id;
        if (on !== a.classList.contains('is-on')) a.classList.toggle('is-on', on);
        if (on) { if (a.getAttribute('aria-current') !== 'true') a.setAttribute('aria-current', 'true'); }
        else if (a.hasAttribute('aria-current')) a.removeAttribute('aria-current');
      });
    }, { rootMargin: '-20% 0px -70% 0px' });
    hs.forEach(function (h) { io.observe(h); });
  }

  function steps(root) {
    var prose = root.querySelector('[data-tier-prose]');
    if (!prose) return;
    var hs = [].slice.call(prose.querySelectorAll('h2'));
    root.querySelectorAll('[data-tier-steps]').forEach(function (a) {
      var want = a.getAttribute('data-tier-steps').trim().toLowerCase().replace(/&amp;/g, '&');
      var h = hs.filter(function (x) { return x.textContent.trim().toLowerCase() === want; })[0];
      if (h && h.id) a.setAttribute('href', '#' + h.id);
    });
  }

  function init() { document.querySelectorAll('[data-mo-tier]').forEach(boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
